// 在这里定义整个项目的mutations
export const UPDATE_KEYWORD = "UPDATE_KEYWORD"
